import { apiEndpointBase } from "./endpoint.config";

// Career service (Amity / Amizone LineUpX SSO).
// The Amizone API can't be called directly from the browser (its CORS preflight
// returns no Access-Control headers), so we hit our own backend, which proxies
// the call server-side. See backend: POST /career/lineupx-login.
const base = apiEndpointBase;

const careerEndpoints = {
  lineUpXLogin: base + "career/lineupx-login",
};

export default careerEndpoints;
